import { req } from '@/req/req.ts';

export async function getUserPermissions(
  userId: string,
): Promise<Array<{ key: string }>> {
  return await req
    .get(`/api/user/uis/by-user/${userId}`)
    .then((res) => res.data.data);
}
